export const smeChamber = `
  <div class="mt-20" data-aos="fade-up"> 
       <div
      class=" w-full lg:w-[80%] mx-auto  p-5  flex flex-col lg:flex-row gap-5 shadow-md rounded-lg bg-[#b8b2ff]"
      data-aos="fade-up"
      data-aos-duration="300"
    >
      
      
      <div class="flex flex-col px-5  items-start justify-between gap-5 h-full">
        <p
          class="text-[10px] font-semibold text-gray-900 px-5 py-1.5 bg-[#fff]/20 rounded-full"
        >
          <img
            src="https://cdn.jsdelivr.net/gh/heisenpreet/ibankeyAssest@master/SME_LOGO.svg"
            alt="SME Chamber of India"
            class="w-35"
          />
        </p>
        <p class="text-xl font-bold text-gray-800">
          iBankey & SME Chamber: Powering Business Growth Together
        </p>
        <p class="text-xs  text-justify font-normal text-gray-700">
         
            As a member of SME Chamber of India, iBankey enables SMEs with
                smart financial solutions, easier access to funding, and growth
                opportunities through a trusted business network.
        </p>
        <button id='smeBtn'
          class="bg-gray-800 hover:bg-gray-900 shadow hover:shadow-xl border-2 hover:underline border-gray-50 text-[#b8b2ff] py-2 px-5 cursor-pointer text-xs font-medium rounded-full"
        >
          See how it works
        </button>
      </div>
      <div class="flex flex-col items-center justify-center flex-1 ">
        <div id="lottie-container" class="w-100">

        </div>
         <p class="text-xs pt-3 text-justify font-medium text-gray-700">
           Fueling the Future of Small and Medium Businesses
        </p>
      </div>
    </div>
    
`;
